import React from 'react';
import axios from 'axios';
import {
  Heading,
  Avatar,
  Box,
  Center,
  Image,
  Flex,
  Text,
  Stack,
  Link,
  Badge,
  Button,
  useColorModeValue,
  Divider,
  SimpleGrid,
  HStack,
} from '@chakra-ui/react';
import { EditIcon } from '@chakra-ui/icons';

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  StackDivider,
} from '@chakra-ui/react';
import {
  chakra,
  Container,
  VStack,
  VisuallyHidden,
  List,
  ListItem,
} from '@chakra-ui/react';

export default function Pvol() {
  const [data, setData] = React.useState([]);
  React.useEffect(() => {
    axios.get('https://glb-api.onrender.com/student/volunteer')
    .then(res => {
      console.log(res.data);

      setData(res.data);
    })
    .catch(err => {
      console.log(err);
      // setError('Failed to fetch the details right now.')
    })
  }, [])
  return (
    <>
      <div>
        <Box>
          <Card variant={'elevated'} minH={'100vh'}>
            <CardBody>
              <Box bg="white" shadow="md" borderRadius="md" p="6" width="100%">
                <Flex alignItems="center" justifyContent="space-between">
                  <Heading as="h1" size="2xl">
                  Volunteering
                  </Heading>
                  <Button
                    leftIcon={<EditIcon />}
                    marginTop={'4px'}
                    colorScheme="blue"
                    variant="outline"
                    size={'lg'}
                    display={{ base: 'none', md: 'inline-flex' }}
                    fontSize={'2xl'}
                    href={'#'}
                  >
                    Edit info
                  </Button>
                </Flex>
              </Box>
              <Box className="mt-10">
                <VStack spacing={10}>
                  <Center width={'100%'}>
                    <Box width={'100%'}>
                      <Card variant={'elevated'}>
                        <CardHeader>
                          <Box bg="white" p={5} borderRadius="md">
                            <Heading as="h2" textAlign="left" size="2xl" mb={3}>
                            {data.title}
                            </Heading>

                            <Flex marginTop={'20px'}>

                              <Box ml="3">
                                <Text fontWeight="bold" fontSize={'x-large'}>
                                  {data.organisation}

                                </Text>
                                <Text fontSize="lg">
                                  January-2023| {data.location}
                                </Text>
                                <Divider marginTop={'10px'} />
                                <Text fontSize="lg" marginTop={"10px"}>
                                {data.description}
                  </Text>

                              </Box>
                            </Flex>
                          </Box>


                        </CardHeader>

                        <CardBody></CardBody>
                      </Card>
                    </Box>
                  </Center>
                </VStack>
              </Box>
              <Box className="mt-10">
                <VStack spacing={10}>
                  <Center width={'100%'}>
                    <Box width={'100%'}>
                      <Card variant={'elevated'}>
                        <CardHeader>
                          <Box bg="white" p={5} borderRadius="md">
                            <Heading as="h2" textAlign="left" size="2xl" mb={3}>
                            Street Children Volunteering Program
                            </Heading>

                            <Flex marginTop={'20px'}>

                              <Box ml="3">
                                <Text fontWeight="bold" fontSize={'x-large'}>
                                  CHL Education Association

                                </Text>
                                <Text fontSize="lg">
                                  January-2023| Indore
                                </Text>
                                <Divider marginTop={'10px'} />
                                <Text fontSize="lg" marginTop={"10px"}>
                                I am honored to have been recognized for my contributions to the Street Children Volunteering Program. This award is a testament to the dedication of our team to making a positive impact on the lives of vulnerable children.

Through my work with the program, I have had the opportunity to witness firsthand the transformative power of community engagement and support. By volunteering my time and expertise, I have been able to contribute to a range of initiatives that provide essential services and support to street children, from education and healthcare to shelter and protection from exploitation.

My role in the program has focused primarily on program design and implementation. Through a combination of research, community outreach, and collaboration with local partners, I have been able to help develop effective, sustainable interventions that address the unique needs of street children and their families.

I am grateful for the opportunity to be a part of such a meaningful and impactful program, and I look forward to continuing to contribute to the fight against child poverty and exploitation in any way I can.
                  </Text>

                              </Box>
                            </Flex>
                          </Box>


                        </CardHeader>

                        <CardBody></CardBody>
                      </Card>
                    </Box>
                  </Center>
                </VStack>
              </Box>
            </CardBody>
          </Card>
        </Box>
      </div>
    </>
  );
}
